import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { INVERTED_METRIC_SWITCH_MAP } from '@utils/metrics';
import { metricSelector } from '@store/metricsChartContainer/selectors';
import ignoreRefetch from '@utils/metrics/ignoreRefetch';
import { queryMetricsAtom } from '../atoms';

// build and manage local list of query metrics to reduce refetches
function useQueryMetrics() {
  const metrics = useSelector(metricSelector);
  const [queryMetrics, setQueryMetrics] = useAtom(queryMetricsAtom);

  useEffect(() => {
    // query toggle metrics(count => pct) if available
    const currentQueryMetrics = [...metrics];
    currentQueryMetrics.forEach((m) => {
      if (m in INVERTED_METRIC_SWITCH_MAP) {
        currentQueryMetrics.push(INVERTED_METRIC_SWITCH_MAP[m]);
      }
    });
    // to avoid DnD causing a query trigger
    currentQueryMetrics.sort();

    if (!ignoreRefetch(currentQueryMetrics, queryMetrics)) {
      setQueryMetrics(currentQueryMetrics);
    }
  }, [metrics]);
}

export default useQueryMetrics;
